module.exports = __webpack_public_path__ + "img/appointment_active.c89aea2a.svg";